import {FaFacebookSquare} from "react-icons/fa";
import {FaLinkedin, FaTwitter} from "react-icons/fa6";
import {Box, Divider, Flex, Icon, Image, Text} from "@chakra-ui/react";
import logo from "../../../assets/images/logo.svg"
import flogo1 from "../../../assets/images/footer-logo-1.png";
import flogo2 from "../../../assets/images/footer-logo-2.png";
import flogo3 from "../../../assets/images/footer-logo-3.png";
import phoneIcon from "../../../assets/images/PhoneOutline.svg";
import mailIcon from "../../../assets/images/MailOutline.svg";
import locIcon from "../../../assets/images/location.svg";

const Footer = () => {

    return (
        <Flex py={'32px'} bg={'white'} px={{base: 4, sm: 0}} w={'100%'}>
            <Box display={{base: 'none', sm: 'flex'}} mx='auto' w={{base: '100%', sm: '7xl'}} flexDirection={'column'} color={'primary'}>
                <Divider borderColor={'#A2C2B0'}/>
                <Flex flexGrow={1} flexDirection={'row'} justifyContent={'space-between'} py={4}>
                    <Flex gap={'48px'}>
                        <Image src={logo} w={120}/>
                        <Flex flexDirection={"column"} alignSelf={"center"} gap={'16px'}>
                            <Flex gap={'16px'}>
                                <Image src={mailIcon} w={'20px'} h={'24px'}/>
                                <Text>stn@stud.umed.lodz.pl</Text>
                            </Flex>
                            <Flex gap={'16px'}>
                                <Text fontFamily={'Poppins'} fontWeight={'400'} fontSize={'16px'} lineHeight={'150%'} color="#1E1E1C">
                                    Studenckie Towarzystwo Naukowe | Uniwersytet Medyczny w Łodzi 2025
                                </Text>
                            </Flex>
                        </Flex>
                    </Flex>
                    <Flex flexDirection={"column"} gap={'10px'}>
                        <Flex justifyContent={'flex-end'} color={'#0B4725'} gap={'32px'} py={'38px'}>
                            <Image src={flogo1} w={137} h={37}/>
                            <Image src={flogo2} w={118} h={37}/>
                            <Image src={flogo3} w={126} h={37}/>
                        </Flex>
                        <Flex justifyContent={'flex-end'} color={'#0B4725'} gap={'32px'}>
                        </Flex>
                        <Flex justifyContent={'flex-end'} color={'#0B4725'} gap={'32px'}>
                            <a href="/polityka-prywatności.pdf" target="_blank" rel="noopener noreferrer">
                                <Text>Polityka prywatności</Text>
                            </a>
                            <a href="/regulamin.pdf" target="_blank" rel="noopener noreferrer">
                                <Text >Regulamin</Text>
                            </a>
                        </Flex>
                    </Flex>
                </Flex>
            </Box>
        </Flex>
    )
}

export default Footer;
